// @ts-nocheck

import ReactDOM from 'react-dom';
export default function Render(containid, node) {
  if (ReactDOM.createRoot) {
    ReactDOM.createRoot(containid).render(node);
  } else {
    ReactDOM.render(node, containid);
  }
}

// import React from 'react';  
// import ReactDOM from 'react-dom';  

// export default function Render(containerId: any, node: React.ReactNode): void {  

//   try {  
//     const ReactDOMClient = require('react-dom/client');  

//     if (ReactDOMClient && typeof ReactDOMClient.createRoot === 'function') {  
//       ReactDOMClient.createRoot(containerId).render(node);  
//       return;  
//     }  
//   } catch (error) {   
//     console.warn('react-dom/client is not available, falling back to ReactDOM.render');  
//   }   
//     ReactDOM.render(node, containerId);

// }